import React from 'react';
import EventsContainer from './EventsContainer';
import FeaturedEventsSidebar from './FeaturedEventsSidebar';

const moment = require('moment-timezone');

export default class CurrentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {featured: [], today: new Date() };
    this.onEvents = this.onEvents.bind(this);
  }

  onEvents(events) {
    const now = Date.now();

    // get the current date (as in calendar date) and hour (24h, no trailing 0) in Vancouver
    const vancouverTime = moment.tz(now, "America/Vancouver");
    const [vancouverDate, vancouverHour] = vancouverTime.format('DD H').split(' ').map(i => Number(i));

    const featured = events.filter(event => {
      if (event.vwwOtd) {
        if ((event.start.getDate() === vancouverDate && vancouverHour >= 9)
            || (event.start.getDate() === vancouverDate - 1 && vancouverHour < 9)) {
          return true;
        }
      }
      return false;
    });

    // const featured = events.filter(event => event.vwwOtd && event.start.getDate() === today);
    for (let i = 0; featured.length < 2; i++) {
      if (!events[i]) {
        break;
      } else {
        if (events[i].end > now && !events[i].vwwOtd) {
          featured.push(events[i]);
        }
      }
    }
    this.setState({ featured });
  }

  render() {
    return(
      <div className="events-container">
        <FeaturedEventsSidebar events={this.state.featured} />
        <EventsContainer
          title="Up Next"
          startDate={this.state.today}
          onEvents={this.onEvents}
          showDayOnTimestamp
          showOptions
          mode={this.props.mode}
       />
     </div>
    );
  }
}